import './scripts/i18n';
import App from './scripts/app';
import AppContext from './scripts/context/app-context';
import AppErrorBoundary from './scripts/error-boundaries/app';
import React from 'react';
import ReactDom from 'react-dom';
import { experimentDebugger } from '@marvelapp/react-ab-test';

//

if (process.env.REACT_APP_FEATURE__EXPERIMENT_DEBUGGER === 'enabled') {
  experimentDebugger.enable();
}

// Render
// ------

ReactDom.render(
  <React.StrictMode>
    <AppContext>
      <AppErrorBoundary>
        <App />
      </AppErrorBoundary>
    </AppContext>
  </React.StrictMode>,
  document.querySelector('.app-container')
);
